export const TextContentData = [
    {
        heading: 'WHAT WE DO',
        content:
            'Studio NORCAT is a multidisciplinary studio that designs and builds applied experiential solutions in support of learning, training, and engagement. Working across virtual reality, augmented reality, software, simulation, and physical installations, the Studio creates tools and experiences that help people build real skills in real-world contexts. Our work brings together technology, design, and learning science to make complex ideas tangible, practical, and actionable.',
    },
    {
        heading: 'HOW WE WORK',
        content:
            'As both a think-tank and a do-tank, Studio NORCAT works closely with partners to explore challenges, prototype ideas, and build applied solutions that matter. Rather than following a fixed process, we adapt our approach to each project. By learning through making and iterating alongside our partners, we focus on outcomes that are practical, scalable, and grounded in real-world use.',
    },
];
